<template>
  <div class="">
     <images v-if="type==0" :imgList="details"></images>
     <document v-else-if="type==1" :source="details"></document>
     <back :category_id="category_id"></back>
  </div>
</template>

<script>
import https from '../https.js' 　
import wx from 'weixin-js-sdk'
import images from "./common/images"
import document from "./common/document"
import back from './common/back'
export default {
  name: 'HelloWorld',
  data () {
    return {
        // 0  "图片" 1  "文档"           2   "链接" 3 "视频"
      type:2,
      title:"",//微信标题
      desc:"",//微信描述
      imgUrl:"",//微信缩略图
      details:"",
      id:"",  //页面传过来的
      category_id:""
    }
  },
   components:{
    "images":images,
    "document":document,
    "back":back,
  },
  created(){
      this.getDetails();
  },
  mounted(){
     
  },
  methods:{
   
    getDetails(){
        // 获取页面传过来的type类型
        this.type=this.$route.query.type;
        //获取页面传过来的id
        this.id=this.$route.query.id;
        var obj={"id":this.id}
        // 加载详细内容
       https.fetchPost("Article/index",obj)
            .then(result=>{
              this.title=result.data.data.category_name;//分享title
               this.desc=result.data.data.post_title;   //分享描述
               var type=this.$route.query.type;
               if(type==1){   //pdf                      //分享图片
                 this.imgUrl='https://book-new.oss-cn-beijing.aliyuncs.com/static/share_def.png'
              }else{         //图片列表
                 this.imgUrl=result.data.data.source_path[0];
              }
                this.details=result.data.data.source_path;
                this.category_id=result.data.data.category_id;

              //微信分享
              var that=this;
                var url=new Object();
                url.url=window.location.href.split('#')[0];
                 https.fetchPost("login/wxShare",url)
                  .then(res=>{
                        var data=res.data.data;
                        var appId=data.appid;
                        var timestamp=data.timestamp;
                        var nonceStr=data.noncestr;
                        var signature=data.signature;
                        
                        var type=this.$route.query.type;  
                        console.log(this.title)
                        wx.config({
                            debug: false,
                            appId: data.appid,
                            timestamp: data.timestamp,
                            nonceStr: data.noncestr,
                            signature: data.signature,
                            jsApiList: [
                                'onMenuShareTimeline',
                                'onMenuShareAppMessage'
                            ]
                        });
                        wx.ready( function() {
                            var title=that.title;
                            var link=window.location.href.split('#')[0]+'static_wap/html/redirect.html?app3Redirect='+encodeURIComponent(window.location.href);
                            var imgUrl=that.imgUrl ; 
                            var desc=that.desc;     //描述信息
                            wx.onMenuShareTimeline({//朋友圈
                                title: title, // 分享标题
                                link: link, // 分享链接
                                imgUrl:imgUrl, // 分享图标
                                success: function () {
                                },
                                cancel: function () {
                                }
                            });
                            wx.onMenuShareAppMessage({//好友
                                title: title, // 分享标题
                                desc:desc, //描述
                                link: link, // 分享链接
                                imgUrl: imgUrl, // 分享图标
                                type: '', // 分享类型,music、video或link，不填默认为link
                                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                                success: function () {},
                                cancel: function () {
                                }
                            });

                        })
                    
                  });  

            })  

        
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/details.vue